import React, { useEffect, useState } from "react";
import Button from "../../../components/Button/Button";
import { FaTimes, FaPaperPlane } from "react-icons/fa";

const SlideOver = ({ open, onClose, title, children }) => {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    if (open) window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[9999] flex" onClick={(e) => e.target === e.currentTarget && onClose?.()}>
      <div className="absolute inset-0 bg-black/50" />
      <div className="relative ml-auto h-full w-full max-w-xl bg-white dark:bg-slate-900 shadow-xl border-l border-gray-200 dark:border-slate-700 p-5 sm:p-6" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white">{title}</h3>
          <button className="h-8 w-8 rounded-full bg-black/10 dark:bg-white/10" onClick={onClose}>×</button>
        </div>
        <div className="mt-4">{children}</div>
      </div>
    </div>
  );
};

const BulkAssignModal = ({ open, onClose, competitions, selectedClubIds, onAssign }) => {
  const [competitionId, setCompetitionId] = useState("");
  const [expiresAt, setExpiresAt] = useState("");

  useEffect(() => {
    if (open) {
      setCompetitionId(competitions?.[0]?.id || "");
      setExpiresAt("");
    }
  }, [open, competitions]);

  const submit = (e) => {
    e.preventDefault();
    if (!competitionId) return;
    onAssign({ competition_id: competitionId, expires_at: expiresAt || null });
  };

  return (
    <SlideOver open={open} onClose={onClose} title="Affecter à une compétition">
      <form onSubmit={submit} className="space-y-4">
        <p className="text-sm text-gray-600 dark:text-gray-300">
          Vous allez affecter <strong>{selectedClubIds.length}</strong> club(s) à la compétition sélectionnée.
        </p>

        <div>
          <label className="block text-sm mb-1">Compétition</label>
          <select
            className="w-full rounded-md border border-gray-300 dark:border-slate-600 bg-white dark:bg-slate-800 px-3 py-2 text-sm dark:text-white"
            value={competitionId}
            onChange={(e) => setCompetitionId(e.target.value)}
          >
            {competitions.map((c) => (
              <option key={c.id} value={c.id}>
                {c.nom_competition} — {new Date(c.date_competition).toLocaleDateString()}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm mb-1">Expiration (facultatif)</label>
          <input
            type="date"
            className="w-full rounded-md border border-gray-300 dark:border-slate-600 bg-white dark:bg-slate-800 px-3 py-2 text-sm dark:text-white"
            value={expiresAt}
            onChange={(e) => setExpiresAt(e.target.value)}
          />
        </div>

        <div className="pt-2 flex items-center justify-end gap-2">
          <Button variant="outline" icon={FaTimes} onClick={onClose} className="rounded-lg">
            Annuler
          </Button>
          <Button type="submit" icon={FaPaperPlane} className="rounded-lg">
            Affecter
          </Button>
        </div>
      </form>
    </SlideOver>
  );
};

export default BulkAssignModal;
